var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import Typography from "../Typography";
import Radio from "./Radio";
import _uniqueId from "lodash/uniqueId";
import PropTypes from "prop-types";
import classnames from "classnames";
var RadioGroup = function (_a) {
    var _b;
    var label = _a.label, options = _a.options, onChange = _a.onChange, _c = _a.className, className = _c === void 0 ? "" : _c, defaultChecked = _a.defaultChecked;
    var _d = useState(defaultChecked || ""), selected = _d[0], setSelected = _d[1];
    var classNames = classnames((_b = {},
        _b["mex-radio-group__wrapper"] = true,
        _b[className] = className,
        _b));
    var handleChange = function (e) {
        setSelected(e.target.value);
        onChange(e);
    };
    var renderOptions = function () {
        return options.map(function (_a, index) {
            var label = _a.label, name = _a.name, value = _a.value, className = _a.className;
            var optionId = useState(_uniqueId("mex-radio-group-id-".concat(index)))[0];
            return (_jsx(Radio, { value: value, label: label, id: optionId, name: name, checked: selected === value, onChange: handleChange, className: className }, optionId));
        });
    };
    return (_jsxs("div", __assign({ className: classNames }, { children: [label && _jsx(Typography, __assign({ variant: "heading05" }, { children: label })), _jsx("div", __assign({ className: "mex-radio-group__render-option" }, { children: renderOptions() }))] })));
};
RadioGroup.displayName = "Radio.Group";
RadioGroup.propTypes = {
    label: PropTypes.string,
    options: PropTypes.array,
    onChange: PropTypes.func,
    className: PropTypes.string,
    defaultChecked: PropTypes.string,
};
export default RadioGroup;
